<template>
  <div class="component-detail-data">
    <div class="search-hd">
      <el-form
        :inline="true"
        size="mini"
        @submit.native.prevent
      >
        <!-- 导出 -->
        <el-form-item style="float: right; margin-right: 0">
          <el-button
            class="table-set"
            style="vertical-align: top"
            @click="dialogVisible = true"
          >
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <el-form-item style="float:right; margin-right: 8px">
          <custom-date-picker
            @change="getData('init')"
            style="width: 260px"
            v-model="times"
            :init-value="initTimer"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="eventIntervalDays"
            size="small"
          ></custom-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table
        :data="tableList"
        :index="true"
        :column="tableColumn"
        :isDrag="false"
        height="100%"
        @filter="filterChange"
        @sort="sortChange"
        @drag="dragChange"
      ></custom-table>
    </div>
    <div class="table-page">
      <el-pagination
        border
        v-if="totalRows"
        @size-change="getData('init')"
        @current-change="getData"
        :current-page.sync="formSearch.pageNum"
        :page-size.sync="formSearch.pageSize"
        :page-sizes="pageSizeList"
        layout="sizes, prev, pager, next, slot, jumper"
        :total="totalRows"
      ></el-pagination>
    </div>
    <device-detail-date-datePicker
      v-if="dialogVisible"
      @close="dialogVisible = false"
      @success="exportTable"
      v-model="exportTimer"
    ></device-detail-date-datePicker>
  </div>
</template>

<script>
import customTable from '@/components/customTable.vue';
import apis from '@/utils/apis.js';
import moment from 'moment';
import deviceDetailDateDatePicker from '@/components/device_detail_date_datePicker.vue';

export default {
  components: {
    customTable, deviceDetailDateDatePicker
  },
  props: {
    model: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      // tableCode: 'device_status_data',
      formSearch: {
        pageSize: 20,
        pageNum: 1
      },
      times: [],
      initTimer: [moment().subtract(3, 'months').format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
      tableList: [],
      tableColumn: [],
      totalRows: null,
      exportTimer: '',
      dialogVisible: false
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData(data) {
      if (data === 'init') {
        this.formSearch.pageNum = 1;
      }
      this.$getJSON(apis.DeviceResumeComponentStatusHistPage, this.getReqData()).then((res) => {
        this.tableList = res.data.pageData.list;
        this.totalRows = res.data.pageData.total;
        if (!this.tableColumn.length) {
          this.tableColumn = this.formatCol(res.data.tableColumns);
        }
      });
    },
    formatCol(list) {
      let shouldFix = true;
      list.forEach((item) => {
        item.columnId = item.tslDataId;
        item.columnName = `${item.dataName} ${item.showUnit ? `${item.showUnit}` : ''}`;
        item.columnCode = item.dataCode;
        item.selected = true;
        item.langColumnName = item.langDataName;
        item.width = item.columnWidth;
        if (item.dicGroup) {
          item.formatRule = 'dic_group';
          item.isFormat = 1;
        }
        if (item.dataType === 'Date') {
          item.formatRule = 'dic_group';
          item.dicGroup = 'tableField_dateFormat_datetime';
          item.formatRule = 'tableField_date';
          item.isFormat = 1;
          // 只给开头连续的日期列添加fixed属性
          if (shouldFix) {
            item.isFixed = true;
            item.fixedPosition = 'left';
          }
        } else {
          // 一旦遇到非日期列，后续不再添加fixed属性
          shouldFix = false;
        }
      });

      return list;
    },
    getReqData() {
      return {
        ...this.formSearch,
        startDate: this.times && this.times[0] ? this.times[0] : '',
        endDate: this.times && this.times[1] ? this.times[1] : '',
        bodyNum: this.model.bodyNum,
        componentCode: this.model.componentCode
      };
    },
    dragChange({ newWidth, col }) {
      this.$postJSON(`${apis.TopicTslColumnWidthSetup}/${col.topicId}/${col.tslDataId}/${newWidth}`).then(() => { });
    },
    // 数据导出
    exportTable: function () {
      const startDate = this.exportTimer && this.exportTimer[0] ? this.exportTimer[0] : undefined;
      const endDate = this.exportTimer && this.exportTimer[1] ? this.exportTimer[1] : undefined;
      this.$exportFlie(apis.DeviceResumeComponentStatusHistExport, {
        bodyNum: this.model.bodyNum,
        componentCode: this.model.componentCode,
        startDate,
        endDate
      }).then(() => { });
    }
  }
};
</script>

<style lang="scss">
.component-detail-data {
  display: flex;
  flex-direction: column;
  height: 100%;
  .el-form-item {
    margin-bottom: 0 !important;
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
